module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/vacant-commercial-property/vacant-commercial-property.component.css
// module id = ./src/app/reports/vacant-commercial-property/vacant-commercial-property.component.css
// module chunks = main